module.exports = __webpack_public_path__ + "img/box_pro_seven_2.fd35a115.jpg";